import { render, staticRenderFns } from "./IdCardStep.vue?vue&type=template&id=f5ce345e&scoped=true"
import script from "./IdCardStep.vue?vue&type=script&lang=js"
export * from "./IdCardStep.vue?vue&type=script&lang=js"
import style0 from "./IdCardStep.vue?vue&type=style&index=0&id=f5ce345e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ce345e",
  null
  
)

export default component.exports